import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { Flex, Form, Input, Button, Typography, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { setCurrentUserInfo, getUserInfoByName } from "../../api/mockData";

const { Title } = Typography;

function Login() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = (values) => {
        setLoading(true);
        setError("");
        
        // 验证用户名和密码
        if (values.username === "Breamit" && values.password === "123456789") {
            // 获取Breamit用户信息
            const breamitUser = getUserInfoByName("Breamit");
            // 切换当前用户
            setCurrentUserInfo(breamitUser);
            // 显示登录成功提示
            message.success("登录成功");
            // 跳转到首页
            navigate("/");
        } else {
            setError("用户名或密码错误");
            message.error("用户名或密码错误");
        }
        
        setLoading(false);
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <Flex className="login-left" vertical justify="center" align="center">
                    <Title level={1} className="login-title">MyBlog</Title>
                </Flex>
                
                <Flex className="login-right" vertical justify="center" align="center">
                    <div className="form-container">
                        <Title level={3} className="form-title">登录</Title>
                        <Form
                            name="login-form"
                            layout="vertical"
                            onFinish={handleLogin}
                            initialValues={{ remember: true }}
                        >
                            <Form.Item
                                name="username"
                                label="用户名"
                                rules={[{ required: true, message: '请输入用户名!' }]}
                            >
                                <Input prefix={<UserOutlined />} placeholder="请输入用户名" />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                label="密码"
                                rules={[{ required: true, message: '请输入密码!' }]}
                            >
                                <Input.Password prefix={<LockOutlined />} placeholder="请输入密码" />
                            </Form.Item>

                            {error && <div className="error-message">{error}</div>}

                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={loading} block>
                                    登录
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Flex>
            </div>
        </div>
    );
}

export default Login;